import { getToken,axiosInstance } from "../utils/Api";
export const createBanner = async (formdata) =>{ 
    try {
        const response = await axiosInstance.post(`/admin/game/createBanner`,formdata,{
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
  } 

  export const deleteBanner = async (id) =>{ 
    try { 
        const response = await axiosInstance.delete(`/admin/game/deletebanner`,{
          data:{banner_id:id},
            headers: { 
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data; 
      } catch (error) {
        throw error;
      } 
}

export const getBannerDetails = async (id) =>{ 
    try { 
        const response = await axiosInstance.get(`admin/game/getBanners?id=${id}`,{
          headers: { 
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data; 
      } catch (error) {
        throw error;
      } 
  }

  export const updateBanner = async (formdata) =>{ 
    try {
        const response = await axiosInstance.put("/admin/game/updateBanner",formdata,{
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
  } 